<div [class]="style">
  <fa-icon [icon]="faMagnifyingGlass" [style]="searchIconStyle" />
  <input type="text" class="flex-grow w-full border-0 bg-[#F6F7F8] outline-none text-xs" [placeholder]="placeholderText" [(ngModel)]="searchText" (ngModelChange)="onChange()" />
</div>
